-- | View-only work-queue state.
-- |
-- | This module contains non-routable, throwaway UI state that should not be
-- | treated as authoritative queue/domain state.
module Steps.WorkQueue.UIState
    ( ExpandedState(..)
    , WorkQueueUiState
    , initialWorkQueueUiState
    , resetWorkQueueUiState
    ) where

import Common

import API.Search (SearchSemester, SearchTeacher, semesterSearchAff, teacherSearchAff)
import API.Types (StudentID)
import Data.Map as Map
import Widgets.BetterSelect (Select, SelectOption, defSelectConfig, initSelect', setSelected)
import Widgets.Search (SearchState, initSearchState)

data ExpandedState = Expanded | Collapsed

type WorkQueueUiState =
    { expandedStudents :: Map StudentID ExpandedState
    , search :: SearchState
    , teacher :: Select SearchTeacher
    -- ^ Teacher select widget state. It mirrors `WorkQueueState.teacher`, which
    -- remains authoritative for document creation and saves.

    , semester :: Select SearchSemester
    -- ^ Semester select widget state. It mirrors `WorkQueueState.semester`,
    -- which remains authoritative for document creation and saves.
    }

initialWorkQueueUiState :: WorkQueueUiState
initialWorkQueueUiState =
    { expandedStudents: Map.empty
    , search: initSearchState
    , teacher: initSelect' "teacher" teacherSearchAff teacherSel
    , semester: initSelect' "semester" semesterSearchAff semesterSel
    }
  where
    teacherSel = defSelectConfig
        { placeholder = Just $ lookupTranslation "search-teacher"
        , allowDeselect = false
        }
    semesterSel = defSelectConfig
        { placeholder = Just $ lookupTranslation "search-semester"
        , allowDeselect = false
        }

resetWorkQueueUiState
    :: Maybe (SelectOption SearchTeacher)
    -> Maybe (SelectOption SearchSemester)
    -> WorkQueueUiState
    -> WorkQueueUiState
resetWorkQueueUiState defTeacher defSemester ui =
    ui
        { expandedStudents = Map.empty
        , teacher = setSelected ui.teacher defTeacher
        , semester = setSelected ui.semester defSemester
        }
